import { literals } from "@/constants/literals";
import { useMemo } from "react";
import InputSelect from "@/components/input-select/InputSelect";
import InputText from "@/components/input-text/InputText";
import {
  PASO_GARAGE_OPTIONS,
  PASO_NOSERV_OPTIONS,
  PASO_EXITS_OPTIONS,
  PUESTO_OPTIONS,
} from "@/constants/selectsLists";
import InputNumber from "@/components/input-number/InputNumber";
import type { PhotosFilters } from "@/types/types.d";

type BasicPhotosSearcherProps = {
  filters: PhotosFilters;
  noCorrectSapOrder: boolean;
  noCorrect9r1: boolean;
  noCorrectCustomer: boolean;
  selectArea: (newArea: string) => void;
  changeFilterCriteria: (value: string | undefined | null, key: string) => void;
};

const BasicPhotosSearcher = ({
  filters,
  noCorrectSapOrder,
  noCorrect9r1,
  noCorrectCustomer,
  selectArea,
  changeFilterCriteria,
}: BasicPhotosSearcherProps) => {
  const steps = useMemo(() => {
    if (!filters.area) {
      return [
        {
          label: literals.selectOption,
          value: "",
        },
      ];
    }
    if (filters.area === literals.noServCell) return PASO_NOSERV_OPTIONS;
    if (filters.area === literals.exits) return PASO_EXITS_OPTIONS;
    return PASO_GARAGE_OPTIONS;
  }, [filters.area]);

  return (
    <>
      <div className="">
        <InputSelect
          size="small"
          label={literals.workstation}
          id="photos-puesto"
          name="photos-puesto"
          options={PUESTO_OPTIONS}
          value={filters.area}
          onChange={selectArea}
          placeholder={literals.workstation}
        />
      </div>
      <div className="">
        <InputSelect
          size="small"
          label={literals.step}
          id="photos-paso"
          name="photos-paso"
          options={steps}
          value={filters.step}
          placeholder={literals.step}
          onChange={(value) => changeFilterCriteria(value, "step")}
          disabled={!filters.area}
        />
      </div>
      <div className="">
        <InputText
          label={literals.customerOrderNoServ}
          placeholder={literals.customerOrderNoServ}
          value={filters.customerOrderNoserv ?? ""}
          size="small"
          onChange={(value) =>
            changeFilterCriteria(value, "customerOrderNoserv")
          }
        />
      </div>
      <div className="">
        <InputText
          label={literals.partIn}
          placeholder={literals.partIn}
          value={filters.orderIn ?? ""}
          size="small"
          onChange={(value) => changeFilterCriteria(value, "orderIn")}
        />
      </div>
      <div className="">
        <InputText
          label={literals.serialIn}
          placeholder={literals.serialIn}
          value={filters.serialIn ?? ""}
          size="small"
          onChange={(value) => changeFilterCriteria(value, "serialIn")}
        />
      </div>
      {/* Row 2 */}
      <InputNumber
        label={literals.workOrder}
        placeholder={literals.workOrder}
        value={filters.sapWorkOrder ?? ""}
        size="small"
        onChange={(value) => changeFilterCriteria(value, "sapWorkOrder")}
        helpText={literals.orderNumberFormat}
        warning={noCorrectSapOrder}
      />

      <div className="">
        <InputText
          label={literals.partOut}
          placeholder={literals.partOut}
          value={filters.orderOut ?? ""}
          size="small"
          onChange={(value) => changeFilterCriteria(value, "orderOut")}
        />
      </div>
      <div className="">
        <InputText
          label={literals.serialOut}
          placeholder={literals.serialOut}
          value={filters.serialOut ?? ""}
          size="small"
          onChange={(value) => changeFilterCriteria(value, "serialOut")}
        />
      </div>
      <InputNumber
        label={literals.document9R1}
        placeholder={literals.document9R1}
        value={filters.document9r1 ?? ""}
        size="small"
        onChange={(value) => changeFilterCriteria(value, "document9r1")}
        helpText={literals.r9Format}
        warning={noCorrect9r1}
      />
      <InputNumber
        label={literals.client}
        placeholder={literals.client}
        value={filters.customer ?? ""}
        size="small"
        onChange={(value) => changeFilterCriteria(value, "customer")}
        helpText={literals.customerFormat}
        warning={noCorrectCustomer}
      />
    </>
  );
};

export default BasicPhotosSearcher;
